import BindingEdit from "../../../../lib/comps/PropPanel/PropPanel/DataSchemaComponents/BindingEdit";
export function getPropPanelContextOptions(vm) {
  const extraComponents = [];
  const customComponents = vm.compMeta.propPanel;
  if (customComponents) Object.keys(customComponents).forEach(id => {
    extraComponents.push({
      settingsSchema: null,
      ...customComponents[id],
      id
    });
  });
  extraComponents.push({
    id: 'BindingEdit',
    component: BindingEdit,
    settingsSchema: {
      type: 'object',
      fields: []
    }
  });
  return {
    ...vm.uc.getDataFormContextOptions({
      extraComponents
    }),
    evalExtraCtx: genExtraCtx(vm)
  };
}
export function genExtraCtx(self) {
  return {
    get style() {
      return self.comp.style || {};
    },
    get events() {
      return self.comp.events || {};
    },
    get bindings() {
      return self.comp.bindings || {};
    },
    get slots() {
      return self.comp.slots || {};
    },
    get scopedSlots() {
      return self.comp.scopedSlots || {};
    },
    get children() {
      return self.comp.children || [];
    },
    get props() {
      return self.compProps;
    },
    get uc() {
      return self.uc;
    },
    get designer() {
      return self.designer;
    },
    get renderer() {
      return self.designer.renderer;
    },
    get compPath() {
      return self.compPath;
    },
    get compInstance() {
      return self.getCompInstance();
    }
  };
}
//# sourceMappingURL=extraCtx.js.map
